import { IanaZone, IsoInstant } from '#.shared/dates/types.ts'
import { instantToDateTime } from '#.shared/dates/utils/convert.ts'
import z from 'zod'

export const TimesheetEventID = z.string().brand<'TimesheetEventID'>()
export type TimesheetEventID = z.infer<typeof TimesheetEventID>

export const TimesheetEvent = z
  .object({
    time_zone_id: IanaZone,
    type: z.string(),
    timestamp: IsoInstant,
    distance: z.float32().optional().nullable(),
  })
  .transform((obj) => ({
    timeZoneId: obj.time_zone_id,
    type: obj.type,
    timestamp: instantToDateTime(obj.timestamp, obj.time_zone_id),
    distance: obj.distance,
  }))

export type TimesheetEventSchema = z.input<typeof TimesheetEvent>
export type TimesheetEvent = z.output<typeof TimesheetEvent>